import { render, staticRenderFns } from "./NovaConversaModal.vue?vue&type=template&id=d89b3b36&scoped=true"
import script from "./NovaConversaModal.vue?vue&type=script&lang=js"
export * from "./NovaConversaModal.vue?vue&type=script&lang=js"
import style0 from "./NovaConversaModal.vue?vue&type=style&index=0&id=d89b3b36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89b3b36",
  null
  
)

export default component.exports